import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import type { FlagDescriptions } from '../../../../shared/featureFlags/types';

export const getGetAllFeatureFlagsQueryKey = (): QueryKey => ['feature-flags', 'all'];

function getAllFeatureFlags() {
  return get<{flags: FlagDescriptions }>('/api/feature_flags');
}

/**
 * Helper hook for fetching feature flags for the admin page.
 * @returns A list of feature flags
 */
export function useGetAllFeatureFlags() {
  return useQuery<{flags: FlagDescriptions }>({
    queryFn: () => getAllFeatureFlags(),
    queryKey: getGetAllFeatureFlagsQueryKey(),
  });
}
